import { useQuery } from '@apollo/client'
import { FC, useMemo } from 'react'
import sortBy from 'lodash/sortBy'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import { FindAllFaq, FindAllFaqVariables } from '__generatedTypes__/FindAllFaq'
import { FaqPages, FaqTypeEnum, OrderDirection } from '__generatedTypes__/globalTypes'
import { FIND_ALL_FAQ } from 'queries/faq'
import { Loader } from 'components/Loader'
import { usePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { getFaqAllowedTypes, getFaqTypeOption } from './consts'
import { Form } from './Form'

type Props = {
  page: FaqPages
  platform?: Platform | null
  className?: string
}

// By default, it uses platform from url, but you can override it via platform prop
export const FormEntity: FC<Props> = ({ page, platform, className }) => {
  const { selectedPlatform: platformParam } = usePlatformsAndSubjects({})
  const selectedPlatform = platform !== undefined ? platform : platformParam
  const allowedTypes = getFaqAllowedTypes(page)

  const { data, loading, refetch } = useQuery<FindAllFaq, FindAllFaqVariables>(FIND_ALL_FAQ, {
    variables: {
      query: {
        take: TAKE_ALL_ITEMS_COUNT,
        order: {
          order: OrderDirection.ASC,
        },
        where: {
          page,
          platform: { id: selectedPlatform?.id },
        },
      },
    },
    skip: !selectedPlatform,
  })

  const initialValues = useMemo(() => {
    const items = data?.findAllFaq?.items || []

    const list = items?.map(({ id, question, answerAsHtml, order, type }) => ({
      entityId: id,
      id,
      question,
      answerAsHtml,
      order,
      type: getFaqTypeOption(type ?? FaqTypeEnum.Standard),
    }))

    return {
      list: sortBy(list, 'order'),
    }
  }, [data])

  if (!selectedPlatform || loading) {
    return <Loader />
  }

  return (
    <div className={className}>
      <Form page={page} allowedTypes={allowedTypes} initialValues={initialValues} refetch={refetch} />
    </div>
  )
}
